import React from 'react';

import { CopyBox } from 'src/dispensary-admin/components/copy-box';
import { isValidHttpUrl as isValidUrl } from 'shared/helpers/utils';

import { ContentContainer, Detail, Title } from '../../components/customize.styles';
import { SelectField } from '../embed.styles';
import {
  InputContainer,
  Container,
  FieldTitle,
  FieldTitleContainer,
  StyledCheckbox,
  StyledCheckmarkIcon,
  OptionsCheckboxGroupContainer,
  StyledTextInput,
  StyledTooltip,
} from './embed-carousel-panel.styles';

// Shared shell for the "Embed Homepage Sections" and "Embed a Collection Carousel" panels on
// Customize > Embed: a picker (caller-supplied), Hide Title / Hide View All Link options, a menu
// URL input, and the generated embed script. Callers own everything about *what* is being
// embedded (the picker's data source and the script's params) and hand the rest to this shell.
export function EmbedCarouselPanel({
  title,
  detail,
  selectFieldTitle,
  selectFieldTestId,
  selectFieldValue,
  selectFieldOptions,
  onSelectFieldChange,
  hideTitle,
  onToggleHideTitle,
  showHideViewAllLinkOption = true,
  hideViewAllLink,
  onToggleHideViewAllLink,
  menuUrlInputId,
  menuUrl,
  onMenuUrlChange,
  menuUrlInputError,
  defaultMenuUrl,
  script,
  displayScript = true,
  scriptPlaceholderText,
}) {
  return (
    <Container>
      <Title>{title}</Title>
      <Detail>{detail}</Detail>

      <ContentContainer>
        <SelectField
          title={selectFieldTitle}
          onChange={onSelectFieldChange}
          value={selectFieldValue}
          options={selectFieldOptions}
          data-testid={selectFieldTestId}
        />

        <OptionsCheckboxGroupContainer>
          <FieldTitleContainer>
            <FieldTitle>Options</FieldTitle>
          </FieldTitleContainer>
          <StyledCheckbox name='hideTitle' label='Hide Title' onChange={onToggleHideTitle} checked={hideTitle} />
          {showHideViewAllLinkOption && (
            <StyledCheckbox
              name='hideViewAllLink'
              label='Hide View All Link'
              onChange={onToggleHideViewAllLink}
              checked={hideViewAllLink}
            />
          )}
        </OptionsCheckboxGroupContainer>

        <FieldTitleContainer>
          <FieldTitle htmlFor={menuUrlInputId}>Menu URL</FieldTitle>
          <StyledTooltip
            arrowRight='103px'
            bottom='30px'
            grey
            iconOpacity={0.7}
            left='auto'
            right='-103px'
            tooltipCopy='We require this URL in order to point users to the right destination when they click a product. Please copy and paste the URL of where your menu is located on your website.'
            width='250px'
          />
        </FieldTitleContainer>
        <InputContainer>
          <StyledTextInput
            id={menuUrlInputId}
            aria-label={menuUrlInputId}
            name='menuUrl'
            placeholder='Paste the URL of your menu'
            onChange={onMenuUrlChange}
            defaultValue={defaultMenuUrl}
            error={menuUrlInputError}
            errorMessage='Please enter a valid url'
          />
          {isValidUrl(menuUrl) && <StyledCheckmarkIcon />}
        </InputContainer>
        <CopyBox
          contentToCopy={script}
          displayContent={isValidUrl(menuUrl) && displayScript}
          placeholderText={scriptPlaceholderText}
        />
      </ContentContainer>
    </Container>
  );
}
